import { render, staticRenderFns } from "./id-card-input.vue?vue&type=template&id=5d22926d&scoped=true&"
import script from "./id-card-input.vue?vue&type=script&lang=js&"
export * from "./id-card-input.vue?vue&type=script&lang=js&"
import style0 from "./id-card-input.vue?vue&type=style&index=0&id=5d22926d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22926d",
  null
  
)

export default component.exports